<template>
<div> 
    <button @click="showStepBar" class="configuratorStepBar-toggle-button" v-bind:class="stepbarButtonClass"
        title="Übersicht der Konfigurations-Schritte"><i class="fal fa-list-ul"></i></button>
    <div class="configurator-stepbar-position-element">
        <div id="configuratorStepBar" class="configurator-stepbar is--hidden" v-bind:class="stepbarClass">
            <div id="stepbarHead">
                <h2 class="configurator-stepbar-headline">
                    Übersicht
                </h2>
                <i @click="hideStepBar" class="configurator-stepbar-icon fal fa-times" id="stepBarCloseButton"></i>
            </div>
            <div id="configuratorStepBarInnerWrapper">
                <div class="configurator-stepbar-step-wrapper">
                    <div v-bind:key="index" v-for="(step, index) in c_notHiddenSteps" class="configurator-stepbar-step-container">
                        <span data-viewID="{$category.id}" id="{$category.id}Entry"
                                class="configurator-stepbar-step" v-bind:class="step.isVisible ? 'current-step brand-color-text' : (step.isAccessible ? 'activated-step' : 'deactivated-step')">
                            <i class="configurator-step-icon" v-bind:class="step.faIcon"></i> {{ step.name }}
                        </span>
                        <span @click="showSpecificStep(step.index)" id="{$category.id}EntryOverlay" class="configurator-stepbar-step-hover-overlay" v-bind:class="step.isVisible ? 'current-step-overlay' : (step.isAccessible ? 'activated-step-overlay' : 'deactivated-step-overlay')"> Zu diesem Schritt
                            <i class="fal fa-arrow-right"></i> 
                        </span>
                    </div>  
                    <!-- Overview-Step -->
                    <div v-if="p_showOverview" class="configurator-stepbar-step-container">
                            <span class="configurator-stepbar-step" v-bind:class="p_isOverviewStepVisible ? 'current-step brand-color-text' : (p_isOverviewStepAccessible ? 'activated-step' : 'deactivated-step')">
                                <i class="configurator-step-icon fal fa-box-check"></i> Zusammenfassung
                            </span>
                            <span @click="showOverviewStep()" class="configurator-stepbar-step-hover-overlay" v-bind:class="p_isOverviewStepVisible ? 'current-step-overlay' : (p_isOverviewStepAccessible ? 'activated-step-overlay' : 'deactivated-step-overlay')"> Zu diesem Schritt
                                <i class="fal fa-arrow-right"></i> 
                            </span>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
const stepbarToggleClass = 'stepbar--hidden';
const stepbarButtonToggleClass = 'stepBar-button-is-hidden';

export default {
  props: {
    p_steps: Array,
    p_showOverview: Boolean,
    p_isOverviewStepVisible: Boolean,
    p_isOverviewStepAccessible: Boolean,
  },
  data() {
      return  {
          stepbarClass: stepbarToggleClass,
          stepWrapperClass: '',
          stepbarButtonClass: '',
      }
  },
  computed: {
      c_notHiddenSteps: function() {
          return this.p_steps.filter(step => !step.isHidden);
      },
  },
  methods: {
      showStepBar() {
          this.stepbarClass = '';
          this.stepbarButtonClass = stepbarButtonToggleClass;
          this.$parent.showStepBar();
      },
      hideStepBar() {
          this.stepbarClass = stepbarToggleClass;
          this.stepbarButtonClass = ''; 
          this.$parent.hideStepBar();
      },
      showSpecificStep(stepIndex) {
          this.$parent.showSpecificStep(stepIndex);
      },
      showOverviewStep() {
          this.$parent.showOverviewStep();
      },
  }
};
</script>

<style language="css">
  @import '../../scss/stepbar/style.css';
</style>



// WEBPACK FOOTER //
// src/components/configurator/Stepbar.vue